import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Menu, LogOut, Bell } from 'lucide-react';

export default function Header({ onMenuClick }) {
  const { user, logout } = useAuth();

  return (
    <header className="h-14 bg-white border-b border-slate-200 flex items-center justify-between px-4 flex-shrink-0" data-testid="header">
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuClick}
          className="lg:hidden p-1.5 hover:bg-slate-100 rounded-md"
          data-testid="menu-toggle-btn"
        >
          <Menu className="w-5 h-5 text-slate-600" />
        </button>
        <h1 className="text-sm font-semibold text-slate-900 hidden sm:block">
          Voucher Management System
        </h1>
      </div>

      <div className="flex items-center gap-2">
        <button className="p-1.5 hover:bg-slate-100 rounded-md relative" data-testid="notifications-btn">
          <Bell className="w-4 h-4 text-slate-500" />
        </button>

        <div className="flex items-center gap-2 pl-2 border-l border-slate-200">
          <div className="text-right hidden sm:block">
            <p className="text-xs font-medium text-slate-900">{user?.name}</p>
            <p className="text-[10px] text-slate-500 uppercase">{user?.role}</p>
          </div>
          <button
            onClick={logout}
            className="p-1.5 hover:bg-slate-100 rounded-md"
            data-testid="logout-btn"
            title="Logout"
          >
            <LogOut className="w-4 h-4 text-slate-500" />
          </button>
        </div>
      </div>
    </header>
  );
}
